{
    "Messages_Type_Label": "Type de message",
    "Messages_Language_Label": "Langue",
    "Messages_Language_DefaultOption": "Valeur par défaut \/ de repli",
    "Messages_Subject_Label": "Sujet",
    "Messages_PlainBody_Label": "Corps (texte brut)",
    "Messages_HtmlBody_Label": "Corps (HTML)",
    "Messages_NewLocale_Info": "Un nouveau message sera créé pour cette langue lors de l'enregistrement.",
    "Messages_Action_Save": "Sauvegarder",
    "Messages_Action_Revert": "Revenir",
    "Messages_Action_Delete": "Supprimer",
    "Messages_DiscardChanges_Prompt": "Supprimer les modifications non enregistrées ?",
    "Messages_DiscardChanges_Confirm": "Rejeter les modifications",
    "Messages_DiscardChanges_Cancel": "Continuez à modifier",
    "Messages_Save_Success": "Message enregistré.",
    "Messages_Save_Error": "Impossible d'enregistrer le message.",
    "Messages_Delete_Success": "Message supprimé.",
    "Messages_Delete_Error": "Impossible de supprimer le message.",
    "NAME": "MessagesLangue"
}